import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
  Form,
  FormGroup,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import moment from "moment";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { v4 as uuidv4 } from "uuid";
import CurrencyInput from "react-currency-input-field";
import { formatValue } from "react-currency-input-field";

function AbonosProveedoresCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_ABONOS_PROVEEDORES = process.env.REACT_APP_URL_ABONOS_PROVEEDORES;
  const URL_COMPRAS = process.env.REACT_APP_URL_COMPRAS;
  const URL_NOTAS_CXP = process.env.REACT_APP_URL_NOTAS_CXP;
  const URL_BANCOS = process.env.REACT_APP_URL_BANCOS;
  const URL_MOVIMIENTOS_BANCOS = process.env.REACT_APP_URL_MOVIMIENTOS_BANCOS;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [text, setText] = useState(false);
  const [proveedores, setProveedores] = useState([]);
  const [selectedProveedor, setSelectedProveedor] = useState("");
  const [selectedProveedorNombre, setSelectedProveedorNombre] = useState("");
  const [fecha, setFecha] = useState(hoy);
  const [concepto, setConcepto] = useState("");

  const [selectedBanco, setSelectedBanco] = useState("");
  const [bancos, setBancos] = useState([]);
  const [moneda, setMoneda] = useState("");

  const [value, setValue] = useState("");
  const [validaBoton, setValidaBoton] = useState(true);
  const [total, setTotal] = useState(0);
  const [importe, setImporte] = useState(0);
  const [selectedNotaCxP, setSelectedNotaCxP] = useState("");
  const [notasDelProveedor, setNotasDelProveedor] = useState([]);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  useMemo(() => {
    axios
    .get(`${URL_PROVEEDORES}Tipo/China`, { 
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allProveedores = response.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(URL_BANCOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allBancos = response.data;
        setBancos(allBancos);
      })
      .catch((err) => {
        console.log(err);
      });

  }, [selectedProveedor]);

  function jalaNotasProveedor(idProveedor) {
    if (!idProveedor) { setNotasDelProveedor([]); return; }
    axios
      .get(`${URL_NOTAS_CXP}Proveedor/${idProveedor}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => {
        setNotasDelProveedor(res.data.filter((n) => n.saldo > 0));
      })
      .catch(() => setNotasDelProveedor([]));
  }

  const savePago = (event) => {
    event.preventDefault();
    setValidaBoton(false);
    const body = {
      fecha,
      importe,
      proveedores: selectedProveedor,
      concepto,
      bancos: selectedBanco,
      ...(selectedNotaCxP ? { notasCxP: selectedNotaCxP } : {}),
    };
    axios.post(URL_ABONOS_PROVEEDORES, body, {
      headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
    })
    .then((data) => {
      // Movimiento bancario
      axios.post(`${URL_MOVIMIENTOS_BANCOS}`, {
        fecha,
        importe: -importe,
        tipo: "Egreso",
        bancos: selectedBanco,
        abonosProveedores: data.data._id,
        moneda,
        tipoCambio: 1,
      }, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      });

      // Si hay notaCxP seleccionada, reducir su saldo
      if (selectedNotaCxP) {
        const nota = notasDelProveedor.find((n) => n._id === selectedNotaCxP);
        const nuevoSaldo = nota ? Math.max(0, nota.saldo - parseFloat(importe)) : 0;
        axios.patch(`${URL_NOTAS_CXP}/${selectedNotaCxP}`, { saldo: nuevoSaldo }, {
          headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
        });
      }

      axios.post(URL_LOGS, {
        tipo: "Crear Pago",
        detalle: `Fecha: ${fecha} / Proveedor: ${selectedProveedor} / Importe: ${importe}`,
        user: user.id,
      }, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      });

      Swal.fire("Good job!", "Creado con exito", "success");
      setTimeout(() => { window.location.reload(); }, 1000);
    })
    .catch((error) => {
      Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!" });
      console.log(error);
      setValidaBoton(true);
    });
  };

  
  const options = proveedores.map((option) => {
    const junta = option.nombre_comercial;
    const firstLetter = option.nombre_comercial[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  function jalaBanco(e) {
    setSelectedBanco(e);
    bancos.map((a) => {
      if (a._id == e) {
        return setMoneda(a.moneda);
      }
    });
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.pagoProveedores ? (
        <div className="card container col-sm-8">
          <h3 align="center">Captura un Pago</h3>
          <Form>
            <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
              <Row>
                <Col md={4}>
                  <Label className="mr-sm-2">Fecha</Label>
                  <Input
                    type="date"
                    value={fecha}
                    required
                    onChange={(e) => {
                      setFecha(e.target.value);
                    }}
                  />
                </Col>
                <Col md={4}>
                  <Label className="mr-sm-2">Proveedor</Label>
                  <Autocomplete
                    size="small"
                    value={value}
                    onChange={(event, selectedProveedor) => {
                      if (selectedProveedor) {
                        setValue(selectedProveedor);
                        setSelectedProveedor(selectedProveedor._id);
                        setSelectedProveedorNombre(selectedProveedor.nombre_comercial);
                        setSelectedNotaCxP("");
                        jalaNotasProveedor(selectedProveedor._id);
                      }
                    }}
                    options={options.sort(
                      (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                    )}
                    groupBy={(option) => option.firstLetter}
                    getOptionLabel={(option) => option.junta}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Selecciona"
                        variant="outlined"
                      />
                    )}
                    renderOption={(option) => (
                      <React.Fragment>
                        {option.codigo} {option.nombre_comercial}
                      </React.Fragment>
                    )}
                  />
                </Col>

                <Col md={3}>
                  <Label className="mr-sm-2">Banco</Label>
                  <Input
                    type="select"
                    value={selectedBanco}
                    onChange={(e) => {
                      jalaBanco(e.target.value);
                    }}
                  >
                    <option value="">Selecciona un Banco</option>
                    {bancos
                      .sort((a, b) => (a.banco > b.banco ? 1 : -1))
                      .map((a) => {
                        return (
                          <option value={a._id}>
                            {a.banco} {a.cuenta}
                          </option>
                        );
                      })}
                  </Input>
                </Col>
                </Row>
                <Row>
                <Col md={4}>
                  <Label className="mr-sm-2">Concepto</Label>
                  <Input
                    type="select"
                    value={concepto}
                    onChange={(e) => {
                      setConcepto(e.target.value);
                    }}
                  >
                    <option value="">Selecciona un Concepto</option>
                    <option value="Abono">Abono</option>
                    <option value="Bonificacion">Bonificacion</option>
                    <option value="Descuento">Descuento</option>
                  </Input>
                </Col>

                <Col sm={4}>
                    <Label for="exampleEmail" className="mr-sm-2">
                      Importe
                    </Label>
                    <Input
                      type="number"
                      min="0"
                      step="any"
                      value={importe}
                        onChange={(e) => setImporte(e.target.value)}
                    />
                  </Col>
              </Row>
              <Row>
                {notasDelProveedor.length > 0 && (
                  <Col md={6}>
                    <Label className="mr-sm-2">Nota CxP (opcional)</Label>
                    <Input
                      type="select"
                      value={selectedNotaCxP}
                      onChange={(e) => setSelectedNotaCxP(e.target.value)}
                    >
                      <option value="">Sin nota específica</option>
                      {notasDelProveedor.map((n) => (
                        <option key={n._id} value={n._id}>
                          #{n.idNotasCxP} — Saldo: ${new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(n.saldo)}
                        </option>
                      ))}
                    </Input>
                  </Col>
                )}
              </Row>
            </FormGroup>
            <br />
            <Row>
              <Button className="btn btn-success" onClick={savePago}>
                {" "}
                Registrar
              </Button>

              <Button
                href="/ListadoAbonosProveedores"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Row>
          </Form>
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
             <h4> Este proceso puede tardar varios segundos.
              <br />
              Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
      
    </>
  );
}

export default AbonosProveedoresCreate;
